module.exports = __webpack_public_path__ + "img/s-class-coupe.309e42b0.jpg";